import classnames from 'classnames';
import React from 'react';

import { Skeleton } from '@components/Skeleton/Skeleton';

import styles from '../Table.module.scss';

interface TableSkeletonProps {
  columns: unknown[];
  skeletonRows?: number;
  isSelectable?: boolean;
}

const renderSkeleton = () => (
  <td className={classnames(styles.col, styles.center)}>
    <Skeleton />
  </td>
);

export const TableSkeleton = ({ columns, skeletonRows = 8, isSelectable }: TableSkeletonProps) => {
  if (skeletonRows <= 0) return null;

  return Array.from({ length: skeletonRows }).map((_, i) => (
    <tr key={`skeleton_${i}`} className={styles.row} data-testid="table-skeleton-row">
      {columns.map((_, i) => (
        <React.Fragment key={i}>
          {isSelectable && i === 0 && renderSkeleton()}
          {renderSkeleton()}
        </React.Fragment>
      ))}
    </tr>
  ));
};
